import { styled, Box } from '@cad-arc';
import { getPriorityFlashBackgroundImage } from '../../../configurable-colors-sounds/priority-flash-image';

function flashCss(flashing: boolean, flashColor: string | undefined): string {
    if (!flashing) {
        return '';
    }
    return `background-image: ${getPriorityFlashBackgroundImage(flashColor)};`;
}

// Colors go through the template, not Box style props: this styled Box renders a plain div, so
// backgroundColor/color props never reach the DOM.
export const PriorityBoxStyled = styled(Box)<{
    $flashing: boolean;
    $flashColor?: string;
    $backgroundColor?: string;
    $color?: string;
    $bold?: boolean;
}>`
    height: 100%;
    width: 100%;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    ${(props) => (props.$bold ? `font-weight: bold;` : ``)}
    ${(props) => flashCss(props.$flashing, props.$flashColor)}
    ${(props) => (props.$backgroundColor ? `background-color: ${props.$backgroundColor};` : ``)}
    ${(props) => (props.$color ? `color: ${props.$color};` : ``)}
`;

/**
 * A styled Box component that flashes if isFlashing is true.
 *
 * This uses an animated png for the animation.
 *
 * @param {Object} props - React component props.
 * @param {boolean} props.isFlashing - Whether the component should flash.
 * @param {string} props.flashColor - #rrggbb color to flash in. Defaults to the red baked into the png.
 * @param {boolean} props.isBold - Set for configured priorities; unconfigured ones keep today's weight.
 */
export const PriorityBox = ({
    children,
    isFlashing,
    flashColor,
    backgroundColor,
    color,
    isBold,
}: {
    children: React.ReactNode;
    isFlashing: boolean;
    flashColor?: string;
    backgroundColor?: string;
    color?: string;
    isBold?: boolean;
}) => {
    return (
        <PriorityBoxStyled
            $flashing={isFlashing}
            $flashColor={flashColor}
            $backgroundColor={backgroundColor}
            $color={color}
            $bold={isBold}
        >
            {children}
        </PriorityBoxStyled>
    );
};
